
<!-- One-line weeks calendar -->
    <div class="calendar-week" *ngIf="displayPeriod !== 'month'">
      <div *ngFor="let day of dates" class="calendar-day"
           [class.today-day]="day.dayIsToday"
           [class.active-day] =  "activeDay && day.dayFullDate.isSame(activeDay.dayFullDate, 'day')"
           (click)="onDayClick(day)"
      >
          <span class="events-day" *ngIf="day.dayEvents?.length >0"></span>
        {{day.dayNumberInMonth}}
      </div>
    </div>




<!-- Multiline-line month calendar -->
    <div class="calendar-wrapper" *ngIf="displayPeriod === 'month'">
      <header class="header">
        <div class="lnr lnr-chevron-left" (click)="changeMonth(false)"></div>
        <div class="title" >{{calendarTitle}}</div>
        <div class="lnr lnr-chevron-right" (click)="changeMonth(true)"></div>
      </header>
<!--      <div class="date-row day-title">-->
<!--        <div class="item" *ngFor="let item of ['Пн','Вт','Ср','Чт','Пт','Сб','Вс']">-->
<!--          {{item}}-->
<!--        </div>-->
<!--      </div>-->
      <div class="date-row" *ngFor="let row of dates">
        <div class="calendar-day" *ngFor="let item of row"
             [class.next]="item[1]==='next'"
             [class.last]="item[1]==='last'"
             [class.other-month-day]="item[3].dayIsOtherMonth"
             [class.today-day]="item[3].dayIsToday"
             [class.active-day] =  "activeDay && item[3].dayFullDate.isSame(activeDay.dayFullDate, 'day')"
             (click)="onDayClick(item[3])"
        >
            <span class="events-day" *ngIf="item[3].dayEvents?.length >0"></span>
          {{item[0]}}
        </div>
      </div>
    </div>





